import { render, staticRenderFns } from "./published.vue?vue&type=template&id=2bacd2c5"
import script from "./published.vue?vue&type=script&lang=js"
export * from "./published.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports